export default "/themes/nutristopa/assets/img/climate.png";